import {
  Dialog,
  DialogContent,
  DialogMessageBox,
  DialogTitle,
} from '@verantos-dev/shared-components';

import { useAnalysisRevertModal } from '../hooks/useAnalysisRevertModal';
import type { AnalysisRevertModalProps } from '../types';
import { DIALOG_PAPER_SX } from './dialogPaperSx';

export const AnalysisRevertModal = ({ onClose }: AnalysisRevertModalProps) => {
  const { title, loadingTitle, loadingText } = useAnalysisRevertModal({ onClose });

  return (
    <Dialog
      id="analysisRevertModal"
      open
      PaperProps={{ sx: DIALOG_PAPER_SX }}
      fullWidth
      maxWidth="lg"
      // Revert is local + instant; the modal closes itself via the hook's
      // visual-delay timer, so backdrop clicks are intentionally inert.
    >
      <DialogTitle id="analysis-revert-modal-title" showClose={false}>
        {title}
      </DialogTitle>
      <DialogContent>
        <DialogMessageBox
          id="analysis-revert-modal-loading"
          title={loadingTitle}
          type="loading"
          text={loadingText}
        />
      </DialogContent>
    </Dialog>
  );
};
